import APIService from '.';

export enum EDayOfTheWeek {
  SUNDAY = 'sunday',
  MONDAY = 'monday',
  TUESDAY = 'tuesday',
  WEDNESDAY = 'wednesday',
  THURSDAY = 'thursday',
  FRIDAY = 'friday',
  SATURDAY = 'saturday'
}

// Weekday indices (0=Sunday..6=Saturday) used by the redemption_days_of_week
// rule. ALL_WEEKDAYS_VALUE is the canonical "every day" value.
export const WEEKDAY_INDEXES = Object.values(EDayOfTheWeek).map(
  (_, index) => index
);
export const ALL_WEEKDAYS_VALUE = WEEKDAY_INDEXES.join();

export interface IOpeningHoursPeriods {
  id?: string;
  createdAt?: Date;
  updatedAt?: Date;
  openTime: string;
  closeTime: string;
  businessLocationId?: string;
  temporaryId?: string;
  openTimeHasNotBeenChanged?: boolean;
  closeTimeHasNotBeenChanged?: boolean;
}

export interface IOpeningHoursData {
  isClosed: boolean;
  periods: IOpeningHoursPeriods[];
}

export interface IOpeningHours {
  enabled?: boolean;
  data?: Record<EDayOfTheWeek, IOpeningHoursData>;
}

class OpeningHoursService extends APIService {
  async getOpeningHours(locationId?: string) {
    return this.get(
      `/admin/opening-hours${locationId ? `?locationId=${locationId}` : ''}`
    );
  }

  async toggleOpeningHours(state: boolean) {
    return this.put('/admin/opening-hours', {
      enabled: state
    });
  }

  async toggleOpeningHoursSync(state: boolean) {
    return this.put('/admin/opening-hours', {
      enabledGoogleSync: state
    });
  }

  async saveOpeningHours(data: IOpeningHours) {
    return this.post('/admin/opening-hours', data);
  }

  async deleteOpeningHour(openingHourId: string) {
    return this.delete(`/admin/opening-hours/${openingHourId}`);
  }
}

export default OpeningHoursService;
